"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  setSourceInitializing: true
};
Object.defineProperty(exports, "setSourceInitializing", {
  enumerable: true,
  get: function get() {
    return _setSourceInitializing["default"];
  }
});
var _setSourceInitializing = _interopRequireDefault(require("./setSourceInitializing"));
var _sourceUpdateStatusManager = require("./sourceUpdateStatusManager");
Object.keys(_sourceUpdateStatusManager).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _sourceUpdateStatusManager[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sourceUpdateStatusManager[key];
    }
  });
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }